import { StrmClassState } from "explorer/reducers/strm-class";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { StrmClassVideo } from "shared/interfaces/StrmClassVideo";
import { Divider } from "antd";
import { motion } from "motion/react";

import "./StrmClass.scss";

const StrmClassDetail: React.FC<RouteComponentProps> = (props) => {
  const { match } = props;
  const {
    params: { id },
  }: any = match;
  const [videoInfo, setVideoInfo] = useState<StrmClassVideo>();
  const { videos } = useSelector((state: StrmClassState) => state.strmClass);
  // const relatedVideos = useMemo(() => {
  //   const tags = videoInfo?.tags || [];

  //   return videos.filter((v) => {
  //     return v.tags.some((tag) => tags.includes(tag));
  //   });
  // }, [videoInfo]);

  useEffect(() => {
    if (videos.length > 0) {
      const video = videos.find((v) => v.id === id);
      setVideoInfo(video);
    }
  }, [id, videos]);

  if (videoInfo) {
    return (
      <div className="strm-class">
        <div className="logo">
          <Logo /> class
        </div>
        <motion.div
          key={videoInfo.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, type: "spring", bounce: 0.3 }}
          className="video-container"
        >
          <iframe
            src={videoInfo.videoUrl}
            title="strm-class"
            className="iframe-video"
          />
        </motion.div>
        <motion.div
          key={`${videoInfo.id}-title`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.5,
            type: "spring",
            bounce: 0.3,
            delay: 0.2,
          }}
          className="video-title-container"
        >
          <h2 className="video-title">{videoInfo.title}</h2>
          <p className="paragraph">{videoInfo.subtitle}</p>
          <Divider />
        </motion.div>
      </div>
    );
  }

  return (
    <div className={`strm-class margin`}>
      <div className="logo">
        <Logo /> class
      </div>
    </div>
  );
};

export default StrmClassDetail;
